module.exports = __webpack_public_path__ + "img/sms-2.54681a2e.png";